<!-- perfil.component.html -->
<div class="container">
    <h1>Mi Panel de Compras</h1>
    <router-outlet></router-outlet>
</div>